import { RSAA } from 'redux-api-middleware';
import endpoints from '../../utils/endpoints';

export const SUBMIT_CALENDAR_REQUEST = 'SUBMIT_CALENDAR_FETCH';
export const SUBMIT_CALENDAR_SUCCESS = 'SUBMIT_CALENDAR_SUCCESS';
export const SUBMIT_CALENDAR_FAILURE = 'SUBMIT_CALENDAR_FAILURE';

export const SUBMIT_CALENDAR_CUTOFF_REQUEST = 'SUBMIT_CALENDAR_CUTOFF_REQUEST';
export const SUBMIT_CALENDAR_CUTOFF_SUCCESS = 'SUBMIT_CALENDAR_CUTOFF_SUCCESS';
export const SUBMIT_CALENDAR_CUTOFF_FAILURE = 'SUBMIT_CALENDAR_CUTOFF_FAILURE';

export const CUT_OFF_MISSED_UPDATE_PAYMENT_DATE = 'CUT_OFF_MISSED_UPDATE_PAYMENT_DATE';
export const CHAPS_CUT_OFF_MISSED_UPDATE_PAYMENT_DATE = 'CHAPS/CUT_OFF_MISSED_UPDATE_PAYMENT_DATE';

export const CLEAR_CALENDAR = 'CLEAR_CALENDAR';

export const fetchCalendar = (calendarType, urgentPayment, IFTPayment = false) => {
	const uri = endpoints.calendar.resolve(null, calendarType);
	const calendatUri = IFTPayment ? `${uri}?urgent=${urgentPayment}` : uri;
	const action = {
		[RSAA]: {
			endpoint: calendatUri,
			method: 'GET',
			types: [SUBMIT_CALENDAR_REQUEST, SUBMIT_CALENDAR_SUCCESS, SUBMIT_CALENDAR_FAILURE],
			headers: { 'x-bpi-version': endpoints.calendar.x_bpi_version },
		},
	};

	return action;
};

export const fetchCutoff = () => {
	const action = {
		[RSAA]: {
			endpoint: endpoints.calendarCutoff.uri,
			method: 'GET',
			types: [SUBMIT_CALENDAR_CUTOFF_REQUEST, SUBMIT_CALENDAR_CUTOFF_SUCCESS, SUBMIT_CALENDAR_CUTOFF_FAILURE],
			headers: { 'x-bpi-version': endpoints.calendarCutoff.x_bpi_version },
		},
	};

	return action;
};

export const cutOffMissedUpdatePaymentDate = (nextAvailableDate) => ({
	type: CUT_OFF_MISSED_UPDATE_PAYMENT_DATE,
	nextAvailableDate,
});

export const cutOffMissedUpdatePaymentChapsDate = (nextAvailableDate) => ({
	type: CHAPS_CUT_OFF_MISSED_UPDATE_PAYMENT_DATE,
	nextAvailableDate,
	meta: {
		allowedDuringApiCall: true,
	},
});
export const clearCalendar = () => ({
	type: CLEAR_CALENDAR,
});
